var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _boundOnSlideEnd, _lifecycleGeneration, _productCard, _reinitQueued, _handleVariantUpdate, _ProductCardMedia_instances, scheduleReinit_fn, teardownRuntime_fn, setupInsideQuickActionsHover_fn, isInsideQuickActionsTarget_fn, resetHoverState_fn, onSlideEnd_fn;
import { Component } from "./component-otnJsBm7.js";
import { CustomEvents } from "./events-yl6bDZlK.js";
import { prefersReducedMotion } from "./utilities-BFAI3Dmv.js";
import { refreshProgressiveImages } from "./progressive-images-mIwHxxsh.js";
import "./critical-ovU0gNB-.js";
import "./waapi-patch-BCt4pEht.js";
import "./cookie-banner-layout-DZP7Q0uT.js";
import "./section-anchor-scroll-Bvm-mXVl.js";
import "./mobile-anim-gate-Btn1wVuD.js";
class ProductCardMedia extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ProductCardMedia_instances);
    __privateAdd(this, _boundOnSlideEnd, null);
    __privateAdd(this, _lifecycleGeneration, 0);
    __privateAdd(this, _productCard, null);
    __privateAdd(this, _reinitQueued, false);
    __privateAdd(this, _handleVariantUpdate, () => __privateMethod(this, _ProductCardMedia_instances, scheduleReinit_fn).call(this));
  }
  connectedCallback() {
    var _a;
    super.connectedCallback();
    __privateSet(this, _lifecycleGeneration, __privateGet(this, _lifecycleGeneration) + 1);
    __privateSet(this, _reinitQueued, false);
    this.quickAddHoverOwners = new Set(
      this.classList.contains("is-quick-add-hover-held") ? ["quick-add-dialog"] : []
    );
    (_a = __privateGet(this, _productCard)) == null ? void 0 : _a.removeEventListener(
      CustomEvents.variantPickerUpdate,
      __privateGet(this, _handleVariantUpdate)
    );
    __privateSet(this, _productCard, this.closest("product-card"));
    if (__privateGet(this, _productCard)) {
      __privateGet(this, _productCard).addEventListener(
        CustomEvents.variantPickerUpdate,
        __privateGet(this, _handleVariantUpdate)
      );
    }
    this.reinit();
  }
  updatedCallback() {
    super.updatedCallback();
    __privateMethod(this, _ProductCardMedia_instances, scheduleReinit_fn).call(this);
  }
  disconnectedCallback() {
    var _a, _b;
    super.disconnectedCallback();
    __privateSet(this, _lifecycleGeneration, __privateGet(this, _lifecycleGeneration) + 1);
    __privateSet(this, _reinitQueued, false);
    (_a = __privateGet(this, _productCard)) == null ? void 0 : _a.removeEventListener(
      CustomEvents.variantPickerUpdate,
      __privateGet(this, _handleVariantUpdate)
    );
    __privateSet(this, _productCard, null);
    __privateMethod(this, _ProductCardMedia_instances, teardownRuntime_fn).call(this, { resetVisualState: true });
    (_b = this.quickAddHoverOwners) == null ? void 0 : _b.clear();
    this.classList.remove("is-quick-add-hover-held");
    this.insideQuickActions = null;
  }
  reinit() {
    var _a, _b, _c, _d;
    if (!this.isConnected) return;
    __privateMethod(this, _ProductCardMedia_instances, teardownRuntime_fn).call(this, { resetVisualState: true });
    (_a = this.quickAddHoverOwners) == null ? void 0 : _a.delete("inside-quick-actions");
    if (!((_b = this.quickAddHoverOwners) == null ? void 0 : _b.size)) {
      this.classList.remove("is-quick-add-hover-held");
    }
    this.abortController = new AbortController();
    const options = { signal: this.abortController.signal };
    this.zones = this.querySelectorAll(".product-card-grid-zone");
    this.dots = this.querySelectorAll(".embla__dot");
    this.galleryInner = this.querySelector(".gallery");
    this.galleryWrapper = this.querySelector(".product-card-media-gallery");
    const card = __privateGet(this, _productCard) ?? this.closest("product-card");
    this.insideQuickActions = (card == null ? void 0 : card.classList.contains(
      "product-card-info--inside"
    )) ? card.querySelector(
      ".product-card-inside-content .product-card-quick-actions"
    ) : null;
    const oldClones = this.querySelectorAll(".gallery__slide.is-clone");
    oldClones.forEach((clone) => clone.remove());
    this.origSlides = Array.from(this.querySelectorAll(".gallery__slide:not(.is-clone)"));
    this.videoWrappers = Array.from(this.querySelectorAll(".product-card-video-wrapper"));
    this.activeDotIndex = -1;
    this.track = null;
    this.totalSlides = 0;
    this.currentIndex = 0;
    this.targetIndex = 0;
    this.transitionEffect = ((_c = this.galleryWrapper) == null ? void 0 : _c.getAttribute("data-transition-effect")) ?? "slide";
    this.direction = ((_d = this.galleryWrapper) == null ? void 0 : _d.getAttribute("data-direction-from")) ?? "right";
    if (this.zones.length > 0) {
      if (this.transitionEffect === "slide") {
        this.initSlideCarousel();
      }
      const { signal } = this.abortController;
      const activateZone = (zone) => {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        this.hoverTimeout = setTimeout(() => {
          this.hoverTimeout = null;
          if (signal.aborted || !this.isConnected) return;
          const index = parseInt(zone.getAttribute("data-zone-index"), 10);
          this.loadVideoAtIndex(index);
          this.syncDots(index - 1);
          this.applyHoverEffect(index);
        }, 75);
      };
      this.zones.forEach((zone) => {
        zone.addEventListener("mouseenter", () => activateZone(zone), options);
        zone.addEventListener("mouseleave", (event) => {
          if (__privateMethod(this, _ProductCardMedia_instances, isInsideQuickActionsTarget_fn).call(this, event.relatedTarget)) return;
          const index = parseInt(zone.getAttribute("data-zone-index"), 10);
          this.pauseVideoAtIndex(index);
        }, options);
      });
      const hoveredZone = Array.from(this.zones).find(
        (zone) => zone.matches(":hover")
      );
      if (hoveredZone) activateZone(hoveredZone);
    } else {
      this.addEventListener("mouseenter", () => {
        this.loadAllVideos();
        refreshProgressiveImages();
      }, options);
      if (this.matches(":hover")) {
        this.loadAllVideos();
        refreshProgressiveImages();
      }
    }
    this.addEventListener("mouseleave", (event) => {
      if (__privateMethod(this, _ProductCardMedia_instances, isInsideQuickActionsTarget_fn).call(this, event.relatedTarget)) {
        this.holdQuickAddHover("inside-quick-actions");
        return;
      }
      if (this.classList.contains("is-quick-add-hover-held")) return;
      __privateMethod(this, _ProductCardMedia_instances, resetHoverState_fn).call(this);
    }, options);
    __privateMethod(this, _ProductCardMedia_instances, setupInsideQuickActionsHover_fn).call(this, options);
  }
  holdQuickAddHover(owner = "quick-add-dialog") {
    this.quickAddHoverOwners ?? (this.quickAddHoverOwners = /* @__PURE__ */ new Set());
    this.quickAddHoverOwners.add(owner);
    this.classList.add("is-quick-add-hover-held");
  }
  releaseQuickAddHover(owner = "quick-add-dialog", relatedTarget = null) {
    var _a, _b;
    (_a = this.quickAddHoverOwners) == null ? void 0 : _a.delete(owner);
    if ((_b = this.quickAddHoverOwners) == null ? void 0 : _b.size) return;
    if (!this.classList.contains("is-quick-add-hover-held")) return;
    this.classList.remove("is-quick-add-hover-held");
    if (relatedTarget instanceof Node && this.contains(relatedTarget) || this.matches(":hover") || this.matches(":focus-within")) {
      return;
    }
    __privateMethod(this, _ProductCardMedia_instances, resetHoverState_fn).call(this);
  }
  // ── Slide Carousel (single-clone wrap-forward) ──────────────────────
  initSlideCarousel() {
    var _a;
    this.track = (_a = this.galleryInner) == null ? void 0 : _a.querySelector(".gallery__container");
    if (!this.track) return;
    this.totalSlides = this.origSlides.length;
    if (this.totalSlides <= 1) return;
    const wrapClone = this.origSlides[0].cloneNode(true);
    wrapClone.classList.add("is-clone");
    wrapClone.removeAttribute("id");
    wrapClone.querySelectorAll("template").forEach((t) => t.remove());
    if (this.direction === "left") {
      wrapClone.style.left = `-${this.totalSlides * 100}%`;
    } else if (this.direction === "top") {
      wrapClone.style.top = `-${this.totalSlides * 100}%`;
    } else if (this.direction === "bottom") {
      wrapClone.style.top = `${this.totalSlides * 100}%`;
    } else {
      wrapClone.style.left = `${this.totalSlides * 100}%`;
    }
    this.track.appendChild(wrapClone);
    this.currentIndex = 0;
    __privateGet(this, _boundOnSlideEnd) ?? __privateSet(this, _boundOnSlideEnd, __privateMethod(this, _ProductCardMedia_instances, onSlideEnd_fn).bind(this));
    this.track.addEventListener("transitionend", __privateGet(this, _boundOnSlideEnd), {
      signal: this.abortController.signal
    });
  }
  /**
   * Move the track to a slide index.
   * @param {number} visualIndex - target layout index to translate the track to
   * @param {number} realIndex - actual slide index to sync logic to
   * @param {boolean} animate - true for smooth transition, false for instant snap
   */
  goTo(visualIndex, realIndex = visualIndex, animate = true) {
    if (!this.track) return;
    if (prefersReducedMotion()) animate = false;
    if (!animate) {
      this.currentIndex = realIndex;
      this.track.classList.add("no-transition");
    }
    this.targetIndex = realIndex;
    const pct = visualIndex * 100;
    const directionMap = {
      right: `translate3d(-${pct}%, 0, 0)`,
      left: `translate3d(${pct}%, 0, 0)`,
      bottom: `translate3d(0, -${pct}%, 0)`,
      top: `translate3d(0, ${pct}%, 0)`
    };
    this.track.style.transform = directionMap[this.direction] ?? directionMap.right;
    if (!animate) {
      const track = this.track;
      if (this.noTransitionRafId) cancelAnimationFrame(this.noTransitionRafId);
      this.noTransitionRafId = requestAnimationFrame(() => {
        if (!this.isConnected || track !== this.track) {
          this.noTransitionRafId = null;
          return;
        }
        this.noTransitionRafId = requestAnimationFrame(() => {
          this.noTransitionRafId = null;
          if (!this.isConnected || track !== this.track) return;
          track.classList.remove("no-transition");
        });
      });
    }
  }
  // ── Hover Effect (both slide & fade) ────────────────────────────────
  applyHoverEffect(zoneIndex) {
    if (!this.galleryInner) return;
    if (zoneIndex === 0) {
      this.galleryInner.removeAttribute("data-active-zone");
    } else {
      this.galleryInner.setAttribute("data-active-zone", zoneIndex);
    }
    refreshProgressiveImages();
    if (this.transitionEffect === "slide" && this.track && this.totalSlides > 1) {
      if (this.hoverRafId) cancelAnimationFrame(this.hoverRafId);
      let targetIndex = zoneIndex === 0 ? 0 : zoneIndex;
      if (zoneIndex === 0) {
        if (this.currentIndex === this.totalSlides - 1) {
          this.goTo(this.totalSlides, this.totalSlides, true);
          return;
        }
      } else {
        if (this.totalSlides > 2 && this.currentIndex === 0 && zoneIndex === this.totalSlides - 1) {
          this.goTo(this.totalSlides, this.totalSlides, false);
          this.hoverRafId = requestAnimationFrame(() => {
            this.hoverRafId = requestAnimationFrame(() => {
              this.hoverRafId = null;
              if (!this.isConnected) return;
              this.goTo(targetIndex, targetIndex, true);
            });
          });
          return;
        }
      }
      this.goTo(targetIndex, targetIndex, true);
    }
  }
  // ── Dots ────────────────────────────────────────────────────────────
  syncDots(index) {
    var _a;
    if (!((_a = this.dots) == null ? void 0 : _a.length) || this.activeDotIndex === index) return;
    this.activeDotIndex = index;
    this.dots.forEach(
      (dot, i) => dot.classList.toggle("embla__dot--selected", i === index)
    );
  }
  // ── Video Helpers ───────────────────────────────────────────────────
  loadVideoAtIndex(index) {
    const slide = this.origSlides[index];
    if (slide) {
      const wrapper = slide.querySelector(".product-card-video-wrapper");
      if (wrapper) {
        this.loadVideo(wrapper);
      }
    }
  }
  pauseVideoAtIndex(index) {
    const slide = this.origSlides[index];
    if (slide) {
      const wrapper = slide.querySelector(".product-card-video-wrapper");
      if (wrapper) {
        this.pauseVideo(wrapper);
      }
    }
  }
  loadAllVideos() {
    var _a;
    (_a = this.videoWrappers) == null ? void 0 : _a.forEach((wrapper) => this.loadVideo(wrapper));
  }
  pauseAllVideos() {
    var _a;
    (_a = this.videoWrappers) == null ? void 0 : _a.forEach((wrapper) => this.pauseVideo(wrapper));
  }
  loadVideo(container) {
    const template = container.querySelector("template.video-template");
    if (template) {
      container.appendChild(template.content.cloneNode(true));
      template.remove();
    } else {
      this.playVideo(container);
    }
  }
  playVideo(container) {
    var _a, _b;
    const iframe = container.querySelector("iframe[data-video-type]");
    if (iframe) {
      (_a = iframe.contentWindow) == null ? void 0 : _a.postMessage(
        iframe.dataset.videoType === "youtube" ? '{"event":"command","func":"playVideo","args":""}' : '{"method":"play"}',
        "*"
      );
    } else {
      (_b = container.querySelector("video")) == null ? void 0 : _b.play();
    }
  }
  pauseVideo(container) {
    var _a, _b;
    const iframe = container.querySelector("iframe[data-video-type]");
    if (iframe) {
      (_a = iframe.contentWindow) == null ? void 0 : _a.postMessage(
        iframe.dataset.videoType === "youtube" ? '{"event":"command","func":"pauseVideo","args":""}' : '{"method":"pause"}',
        "*"
      );
    } else {
      (_b = container.querySelector("video")) == null ? void 0 : _b.pause();
    }
  }
}
_boundOnSlideEnd = new WeakMap();
_lifecycleGeneration = new WeakMap();
_productCard = new WeakMap();
_reinitQueued = new WeakMap();
_handleVariantUpdate = new WeakMap();
_ProductCardMedia_instances = new WeakSet();
scheduleReinit_fn = function() {
  if (__privateGet(this, _reinitQueued)) return;
  __privateSet(this, _reinitQueued, true);
  const generation = __privateGet(this, _lifecycleGeneration);
  queueMicrotask(() => {
    __privateSet(this, _reinitQueued, false);
    if (!this.isConnected || generation !== __privateGet(this, _lifecycleGeneration)) return;
    this.reinit();
  });
};
teardownRuntime_fn = function({ resetVisualState = false } = {}) {
  var _a, _b, _c, _d;
  (_a = this.abortController) == null ? void 0 : _a.abort();
  this.abortController = null;
  if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
  this.hoverTimeout = null;
  if (this.hoverRafId) cancelAnimationFrame(this.hoverRafId);
  this.hoverRafId = null;
  if (this.noTransitionRafId) cancelAnimationFrame(this.noTransitionRafId);
  this.noTransitionRafId = null;
  if (this.track && __privateGet(this, _boundOnSlideEnd)) {
    this.track.removeEventListener("transitionend", __privateGet(this, _boundOnSlideEnd));
  }
  if (!resetVisualState) return;
  this.pauseAllVideos();
  (_b = this.galleryInner) == null ? void 0 : _b.removeAttribute("data-active-zone");
  (_c = this.track) == null ? void 0 : _c.classList.remove("no-transition");
  (_d = this.track) == null ? void 0 : _d.style.removeProperty("transform");
};
setupInsideQuickActionsHover_fn = function(options) {
  const quickActions = this.insideQuickActions;
  if (!quickActions) return;
  const hold = () => this.holdQuickAddHover("inside-quick-actions");
  const release = (event) => {
    if (event.relatedTarget instanceof Node && quickActions.contains(event.relatedTarget)) {
      return;
    }
    this.releaseQuickAddHover("inside-quick-actions", event.relatedTarget);
  };
  quickActions.addEventListener("mouseenter", hold, options);
  quickActions.addEventListener("mouseleave", release, options);
  quickActions.addEventListener("focusin", hold, options);
  quickActions.addEventListener("focusout", release, options);
  if (quickActions.matches(":hover") || quickActions.matches(":focus-within")) hold();
};
isInsideQuickActionsTarget_fn = function(target) {
  var _a;
  return target instanceof Node && Boolean((_a = this.insideQuickActions) == null ? void 0 : _a.contains(target));
};
resetHoverState_fn = function() {
  var _a;
  if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
  this.hoverTimeout = null;
  if ((_a = this.zones) == null ? void 0 : _a.length) {
    this.syncDots(0);
    this.applyHoverEffect(0);
  }
  this.pauseAllVideos();
};
onSlideEnd_fn = function(e) {
  if (e.target !== this.track || e.propertyName !== "transform") return;
  if (this.targetIndex !== void 0) {
    this.currentIndex = this.targetIndex;
  }
  if (this.currentIndex >= this.totalSlides) {
    this.goTo(0, 0, false);
  }
};
if (!customElements.get("product-card-media")) {
  customElements.define("product-card-media", ProductCardMedia);
}
export {
  ProductCardMedia
};
